import React from 'react';
import { render } from "react-dom";
import { Provider } from "react-redux";
import store from "./store";
import App from './App';

const target = document.querySelector("#root")

render(
  <Provider store={store}>
    <App />
  </Provider>,
  target
);


// WEBPACK FOOTER //
// ./src/index.js